import Vue from 'vue'
function vuexCreatorVision(store) {
	async function initialize() {
		store.subscribe(async mutation => {
			try {
				// Get the module name and type of mutation
				const [moduleName, mutationType] = mutation.type.split('/')
				if (moduleName === 'media') {
					if (mutationType === 'SET') {
						console.log('Media was set', mutation)
						const existingMedia =
							store.state.creatorVision.mediaOutliers[mutation.payload.visionId]
						if (existingMedia) {
							console.log('Updating existing outlier', existingMedia)
							Object.keys(mutation.payload).forEach(key => {
								if (key in mutation.payload && key in existingMedia) {
									if (existingMedia[key] !== mutation.payload[key]) {
										console.log(
											'Updating outlier media',
											key,
											' to ',
											mutation.payload[key]
										)
										if (
											typeof existingMedia[key] !==
											typeof mutation.payload[key]
										) {
											console.log('Type mismatch', key)
											// ignore it
											return
										} else {
										}
										console.log(
											'Updating outlier media',
											key,
											' to ',
											mutation.payload[key]
										)
										Vue.set(existingMedia, key, mutation.payload[key])
									} else {
										console.log(
											'Outlier keys dont match up',
											key,
											existingMedia,
											mutation.payload
										)
									}
								} else {
									console.log(
										'Outlier key not in both objects',
										key,
										existingMedia,
										mutation.payload
									)
								}
							})
						}
					}
				}
			} catch (e) {
				console.error(e)
			}
		})
	}
	initialize()
}
export default vuexCreatorVision
